import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { BrandProvider } from "@/contexts/BrandContext";
import ProtectedRoute from "@/components/app/ProtectedRoute";
import AppLayout from "@/components/app/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Brands from "@/pages/Brands";
import Products from "@/pages/Products";
import Categories from "@/pages/Categories";
import CompareWeeks from "@/pages/CompareWeeks";
import Competitors from "@/pages/Competitors";
import Clusters from "@/pages/Clusters";
import Upload from "@/pages/Upload";
import AdsPerformance from "@/pages/AdsPerformance";
import CategoryNegatives from "@/pages/CategoryNegatives";
import SearchTerms from "@/pages/SearchTerms";
import ClusterDashboard from "@/pages/ClusterDashboard";
import ProductOpportunity from "@/pages/ProductOpportunity";
import CompetitorIntel from "@/pages/CompetitorIntel";
import Settings from "@/pages/Settings";
import Templates from "@/pages/Templates";
import Bidding from "@/pages/Bidding";
import ListingOptimization from "@/pages/ListingOptimization";
import ProductGaps from "@/pages/ProductGaps";
import Strategy from "@/pages/Strategy";
import Execution from "@/pages/Execution";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import DataManagement from "@/pages/DataManagement";
import Repository from "@/pages/Repository";
import ComingSoon from "@/pages/ComingSoon";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <BrandProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
              <Route index element={<Dashboard />} />
              <Route path="/brands" element={<Brands />} />
              <Route path="/products" element={<Products />} />
              <Route path="/categories" element={<Categories />} />
              <Route path="/compare" element={<CompareWeeks />} />
              <Route path="/competitors" element={<Competitors />} />
              <Route path="/clusters" element={<Clusters />} />
              <Route path="/templates" element={<Templates />} />
              <Route path="/upload" element={<Upload />} />
              <Route path="/ads-performance" element={<AdsPerformance />} />
              <Route path="/category-negatives" element={<CategoryNegatives />} />
              <Route path="/search-terms" element={<SearchTerms />} />
              <Route path="/clusters-dashboard" element={<ClusterDashboard />} />
              <Route path="/product-opportunity" element={<ProductOpportunity />} />
              <Route path="/competitors-intel" element={<CompetitorIntel />} />
              <Route path="/bidding" element={<Bidding />} />
              <Route path="/listing" element={<ListingOptimization />} />
              <Route path="/gaps" element={<ProductGaps />} />
              <Route path="/strategy" element={<Strategy />} />
              <Route path="/execution" element={<Execution />} />
              <Route path="/reports" element={<Reports />} />
              <Route path="/users" element={<Users />} />
              <Route path="/data-management" element={<DataManagement />} />
              <Route path="/repository" element={<Repository />} />
              <Route path="/settings" element={<Settings />} />
            </Route>
          </Routes>
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </BrandProvider>
    </AuthProvider>
  );
}

export default App;
